import bPopover from './popover';
import { registerDirectives, vueUse } from '../../utils/plugins';

var directives = {
  bPopover: bPopover
};

var VuePlugin = {
  install: function install(Vue) {
    registerDirectives(Vue, directives);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/popover/index.js
// module id = inTl
// module chunks = 40